import React from 'react';
interface ArtworkCardProps {
  artist: string;
  title: string;
  medium: string;
  dimensions: string;
  price: string;
  imageUrl: string;
  aspectRatio?: 'portrait' | 'landscape' | 'square';
}
export function ArtworkCard({
  artist,
  title,
  medium,
  dimensions,
  price,
  imageUrl,
  aspectRatio = 'portrait'
}: ArtworkCardProps) {
  // Determine height class based on aspect ratio
  const heightClass = {
    portrait: 'aspect-[3/4]',
    landscape: 'aspect-[4/3]',
    square: 'aspect-square'
  }[aspectRatio];
  return <div className="group flex flex-col space-y-6" data-id="element-1">
      <div className="p-4 border border-black transition-transform duration-500 ease-out group-hover:scale-[1.02] bg-white" data-id="element-2">
        <div className={`w-full ${heightClass} overflow-hidden bg-gray-50`} data-id="element-3">
          <img src={imageUrl} alt={`${title} by ${artist}`} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-4" />
        </div>
      </div>

      <div className="space-y-1 px-1" data-id="element-5">
        <h3 className="text-xl font-medium tracking-wide" data-id="element-6">{artist}</h3>
        <p className="text-lg italic text-gray-800" data-id="element-7">{title}</p>
        <div className="pt-2 text-sm font-sans text-gray-500 space-y-0.5" data-id="element-8">
          <p data-id="element-9">{medium}</p>
          <p data-id="element-10">{dimensions}</p>
          <p className="text-black font-medium pt-1" data-id="element-11">{price}</p>
        </div>
      </div>
    </div>;
}